import React from 'react';
import { ShoppingCart } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  subtext?: string;
  icon?: React.ReactNode;
}
export function Button({
  children,
  className = '',
  subtext,
  icon
}: ButtonProps) {
  return <a href="https://colorpack.store/cart/45917604184262:1" className={`group relative flex flex-col items-center justify-center w-full max-w-2xl mx-auto p-4 sm:p-6 rounded-xl bg-gold-gradient text-black font-bold uppercase tracking-wide transition-all duration-300 hover:scale-105 hover:shadow-gold-lg animate-pulse-scale ${className}`} data-id="element-253">
      <div className="flex items-center justify-center gap-3 text-xl sm:text-2xl md:text-3xl font-oswald text-center drop-shadow-md" data-id="element-254">
        {icon || <ShoppingCart className="w-6 h-6 sm:w-8 sm:h-8" data-id="element-255" />}
        <span data-id="element-256">{children}</span>
      </div>
      {subtext && <span className="mt-2 text-xs sm:text-sm font-inter font-semibold opacity-80 normal-case tracking-normal text-center" data-id="element-257">
          {subtext}
        </span>}

      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:animate-[shimmer_1.5s_infinite] skew-x-12" data-id="element-258" />
    </a>;
}